<template>
    <div>
		<!-- User Interface controls -->
        <b-row>
            <b-col md="7" class="my-1">
                <b-form-group class="mb-0">
                    <b-input-group>
                        <b-form-input v-model="filter" placeholder="Type to Search" />
                        <b-input-group-append>
                            <b-btn :disabled="!filter" @click="filter = ''">Clear</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="5" class="my-1">
                <b-form-group label-cols-md="4" label="Per page" class="mb-0">
                    <b-form-select :options="pageOptions" v-model="perPage" />
                </b-form-group>
            </b-col>
        </b-row>
        <!-- Main table element -->
            <b-table show-empty empty-text="Please wait while the evaluations load." striped responsive stacked="md" 
                 :items="items" 
                 :fields="fields" 
                  :filter="filter" 
                  :sort-by.sync="sortBy"
				 :sort-desc.sync="sortDesc"
                 @filtered="onFiltered">
			<template v-slot:cell(preceptor_name)="row">
				{{ row.item.preceptor_name }}<br>
				<!-- <b-link v-if="role == 'school'" @click="remind(row.item.id)">
					Remind
				</b-link> -->
			</template>
			<template v-slot:cell(created_at)="row">
				{{ moment(row.item.created_at).format('MMM DD YYYY') }}
			</template>
<template v-slot:cell(actions)="row" class="text-nowrap">
                <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
                <b-button-group>
                    <b-button @click="viewEvaluation(row.item.id)" class="btn btn-success">
                        <span class="icon icon-eye">
                            View</span>
                    </b-button>
						<b-button v-if="role =='student'" @click="editEvaluation(row.item.id)" class="btn btn-warning">
						<span class="icon icon-pencil"></span>
            </b-button>
					<b-button v-if="role =='student'" @click="info(row.item.preceptor_name, row.item.id, $event.target)" class="btn btn-danger">
          <span class="icon icon-trash"></span>
            </b-button>
                </b-button-group>
            </template>
</b-table>
<!-- Info modal -->
    <b-modal ok-title="Yes Delete" cancel-title="Cancel" ok-variant="danger" cancel-variant="primary" id="modalInfo" @hide="resetModal" @ok="deleteAssessment" :title="modalInfo.title">
      <p>{{ modalInfo.content }}</p>
    </b-modal>
	<b-row>
          <b-col md="6" class="my-1">
            <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" class="my-0" />
          </b-col>
        </b-row>
</div>
</template>

<script>
	const items = [];
	var moment = require('moment');
	export default {
		props: ['evaluations', 'surl', 'user_role'],
		data() {
			return {
				items: this.evaluations,
				url: this.surl,
				role: this.user_role,
				moment: moment,
				fields: [{
						key: "rotation",
						label: "Rotation",
					},
					{
						key: "preceptor_name",
						label: "Preceptor",
					},
					{
						key: "created_at",
						label: "Sent",
					},
					{
						key: "actions",
						label: "Actions"
					}
				],
				filter: null,
				sortBy: "created_at",
				sortDesc: true,
				modalInfo: { title: '', content: '', id: '' },
				totalRows: this.evaluations.length,
				pageOptions: [15, 25, 35, 50],
				currentPage: 1,
				perPage: 25,
			};
		},
		computed: {
			sortOptions() {
				// Create an options list from our fields
				return this.fields.filter(f => f.sortable).map(f => {
					return {
						text: f.label,
						value: f.key
					};
				});
			}
		},
		filters: {
			uppercase: function(v) {
				return v.toUpperCase();
			}
		},
		methods: {
			onFiltered(filteredItems) {
				// Trigger pagination to update the number of buttons/pages due to filtering
				this.totalRows = filteredItems.length;
				this.currentPage = 1;
			},
			viewEvaluation(id) {
				window.location.href = this.surl + id;
			},
			editEvaluation(id) {
				window.location.href = "/student/edit/sent-evaluation/" + id;
			},
			remind(id) {
				axios
				.get("/instructor/student/pending/evaluation/reminder/" + id)
				.then(response => (this.items = response.data))
				.catch(function(error) {
					console.log(error);
				});
				swal({
				title: "Reminder Sent!",
				icon: "success",
				});
			},
			info(preceptor_name, id, button) {
        this.modalInfo.title = `Are you sure you want to delete?`
        this.modalInfo.content = "This Evaluation for " + preceptor_name + ". They will be notified."
        this.modalInfo.id = id
        this.$root.$emit('bv::show::modal', 'modalInfo', button)
      },
    resetModal() {
        this.modalInfo.title = ''
        this.modalInfo.content = ''
        this.modalInfo.id = ''
    },
    deleteAssessment(id) {
       axios.get('/student/delete/sent-evaluation/' + this.modalInfo.id)
            .then(response => this.items = response.data)
            .catch(function (error) {
                // handle error
                console.log(error);
            });
            swal({
          title: "Evaluation Deleted!",
          icon: "success"
        });
        this.modalInfo.title = ''
      this.modalInfo.content = ''
      this.modalInfo.id = ''
    },
			
			},
	};
</script>

<!-- table-complete-1.vue -->